import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import AdultIcon from '../icons/adultIcon'
import ChildIcon from '../icons/childIcon'

const AgeCategorySelector = ({ ageCategory, onSelect, bgSelected, btnCss, personErrors }) => (
  <div className="flex">
    <button
      id="ageCategory"
      name="ageCategory"
      type="button"
      onClick={() => onSelect('ageCategory', 'adult')}
      value="adult"
      className={`${ageCategory === 'adult' ? `text-harbor ${bgSelected}`  : 'text-grey-dark'} ${btnCss} flex items-center text-left focus:outline-none`}
    >
      <div className={`flex items-center justify-center rounded-full w-14 h-14 border mr-3 ${ageCategory === 'adult' && 'border-blue-darkest'} ${personErrors.ageCategory && 'border-red'}`}>
        <AdultIcon sizeCss="w-8 h-8" textCss={`${ageCategory === 'adult' ? 'text-harbor' : 'text-grey'}`} />
      </div>
      <div className="font-bold text-sm flex items-center mr-3">
        <FormattedMessage
          id='booking.person.adult'
          defaultMessage='Adult'
        />
      </div>
    </button>

    <button
      id="ageCategory"
      name="ageCategory"
      type="button"
      onClick={() => onSelect('ageCategory', 'child')}
      value="child"
      className={`${ageCategory === 'child' ? `text-harbor ${bgSelected}` : 'text-grey-dark'} ${btnCss} flex items-center text-left focus:outline-none`}
    >
      <div className={`flex items-center justify-center rounded-full w-14 h-14 border mr-3 ${ageCategory === 'child' && 'border-blue-darkest'} ${personErrors.ageCategory && 'border-red'}`}>
        <ChildIcon sizeCss="w-8 h-8" textCss={`${ageCategory === 'child' ? 'text-harbor' : 'text-grey'}`} />
      </div>
      <div className="text-sm flex flex-col justify-center">
        <div className="font-bold">
          <FormattedMessage
            id='booking.person.child'
            defaultMessage='Child'
          />
        </div>
        <div className="text-xs">
          <FormattedMessage
            id='booking.person.childLn2'
            defaultMessage='Under 10 years'
          />
        </div>
      </div>
    </button>
  </div>
)

AgeCategorySelector.propTypes = {
  ageCategory: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  bgSelected: PropTypes.string,
  btnCss: PropTypes.string,
  personErrors: PropTypes.shape({ booking: PropTypes.object })
}

AgeCategorySelector.defaultProps = {
  ageCategory: '',
  bgSelected: '',
  btnCss: '',
  personErrors: {}
}

export default AgeCategorySelector